
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import { Options, Vue } from "vue-class-component"; //基本需要\
import { ElMessage } from "element-plus";
import {
  dispatchGetNewReportList,
  dispatchGetReportDetail,
  dispatchGetSkinReport,
  dispatchUploadReportImage,
  dispatchDeleteReport,
  dispatchtaskRecordDevices,
  dispatchAovCopyPerfToReport,
  dispatchtaskRecordQuery,
  dispatchRecentTaskrecord,
  dispatchCreateReportByTask,
  dispatchGetPerformanceVersion,
  dispatchCreateReport,
  dispatchClearCache,
  dispatchGetDateVersionList,
  dispatchUpdateReport,
} from "@/store/performance/actions";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import {
  readDateVersions,
  readNewReportList,
  readNewReport,
  readSkinReport,
  readTaskRecordQuery,
  readTaskRecordDevices,
  readRecentTaskrecord,
  readPerformanceVersion,
} from "@/store/performance/getters"; //引入仓库接口
import { store } from "@/store"; //引入仓库
import {
  readHeroSkin,
  readMobaProjects,
  readUserProfile,
} from "@/store/main/getters";
import {
  dispatchGetHeroSkin,
  dispatchGetMobaProjects,
  dispatchUpdateMyLastProject,
} from "@/store/main/actions";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import {
  readMyProjects,
  readProjectDetail,
  readAdminProjects,
} from "@/store/project/getters";
// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class TestReportSkin extends Vue {
  public localProject = Number(getLocalProject()); //得到本地的项目
  public resBase64: any[] = [];
  //报告名称
  public contrast = true;
  public loading = false; //加载
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public edit = false;
  public form1 = {
    name: "",
  };
  public getBaseline(show) {
    var baseline = {
      show4: { min_fps: 14, avg_fps: 25 },
      show3: { min_fps: 14, avg_fps: 24 },
      show2: { min_fps: 18, avg_fps: 25 },
      show1: { min_fps: 35, avg_fps: 35 },
    };
    return baseline[show];
  }
  public getAvg_fps(v) {
    console.log(this.getBaseline(this.getDeviceShow(v)).avg_fps);
    if (v.avg_fps < this.getBaseline(this.getDeviceShow(v)).avg_fps) {
      return "red";
    }
  }
  public getDeviceShow(item) {
    let deviceName = item.model;
    var deviceConfig = {
      show4: ["SM-J200"],
      show3: ["iPhone 6p", "OPPO A33"],
      show2: ["华为Y7", "三星J7", "小米红米Note 4", "OPPO A59S"],
      show1: ["Redmi Note 8", "ROG 2", "iPhone 7 Plus", "iPhone X", "OPPO R11"],
    };
    if (deviceConfig["show1"].includes(deviceName)) {
      return "show1";
    } else if (deviceConfig["show2"].includes(deviceName)) {
      return "show2";
    } else if (deviceConfig["show3"].includes(deviceName)) {
      return "show3";
    } else {
      return "show4";
    }
  }
  public btn(r, i) {
    let input: any = document.getElementById("input");
    (input as any).value = this.get_url(r);
    input.select();
    document.execCommand("copy");
    ElMessage({
      showClose: true,
      message: "当前信息已复制",
      type: "success",
    });
  }
  public dialogFormVisible1 = false;
  public handleEdit() {
    this.dialogFormVisible1 = true;
    this.form1.name = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.report_id
    )[0].report_name;
    // this.form1.name=edit_name.slice(0,edit_name.indexOf('】')+1)
  }
  public async mounted() {
    const project = Number(this.$route.query.project);
    // this.formMail.title = (readNewReportList(store) as any[]).filter(
    //   (item: any) => item.id === this.report_id
    // )[0].report_name;
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 3,
    });
    await dispatchGetMobaProjects(store, project);
    await dispatchGetReportDetail(store, {
      project: project,
      id: Number(this.$route.query.report_id),
    });

    if (this.$route.query.report_id) {
      this.report_id = Number(this.$route.query.report_id);
      this.formMail.title = (readNewReportList(store) as any[]).filter(
        (item: any) => item.id === this.report_id
      )[0].report_name;
      await dispatchRecentTaskrecord(store, {
        project: project,
        report_type: 3,
      }); //表格对应label
      await dispatchGetDateVersionList(store, {
        project: project,
        report_type: 3,
      });
    } else {
      this.report_id = this.nameList[0] ? this.nameList[0]?.id : 0;
      await dispatchRecentTaskrecord(store, {
        project: project,
        report_type: 3,
      }); //表格对应label
      await dispatchGetDateVersionList(store, {
        project: project,
        report_type: 3,
      });
    }
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    if (this.report_id) {
      await dispatchGetSkinReport(store, {
        project: this.localProject,
        report_id: this.report_id,
      });
    }
    await dispatchGetProjectDetail(store, {
      id: this.localProject,
      project: this.localProject,
    });
    await dispatchtaskRecordQuery(store, {
      project: this.localProject,
      task_record_id: "",
    }); //aov复制数据需要的任务记录列表接口
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: "",
    }); //获取任务记录的设备

    await this.addressee;
    await this.get_create_report();
    await this.getSkinReport();
    // console.log(this.nameList);
    // if (this.$route.query.report_id) {
    //   if (this.$route.query.project) {
    //     const project = Number(this.$route.query.project);
    //     await dispatchGetNewReportList(store, { project: this.localProject });
    //      await dispatchGetPerfReport(store, {
    //       project: project,
    //       report_id: Number(this.$route.query.report_id),
    //     });
    //   }
    // } else {
    //   await dispatchGetNewReportList(store, { project: this.localProject });
    //   (this.name_search as any) = readNewReportList(store)[0].id;
    //   this.$router.push({
    //     query: { ...this.$route.query, report_id: this.name_search },
    //   });
    //   this.formMail.title = (readNewReportList(store) as any[]).filter(
    //     (item: any) => item.id === this.name_search
    //   )[0].report_name;
    // }
  }
  public get RecentTaskrecord() {
    return readRecentTaskrecord(store);
  }
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }
  //报告名称
  public report_id = 0;
  // 核心数据类型
  public get_skin_data = {
    model_list: {},
    new_version: "",
    old_version: "",
    project: {
      icon: "",
      project_name: "",
    },
    base: {
      creator: "",
      date: "",
      skin_num: 0,
      version: "",
    },
    device_list: [],
  };
  //获取报告名称的列表
  public get nameList() {
    let name_list: any[] = [];
    name_list = readNewReportList(store);
    return name_list;
  }
  // 报告名称切换时
  public async change_name_search() {
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 3,
    });
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.report_id
    )[0].report_name;
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.report_id),
    });
    await dispatchGetSkinReport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    await this.getSkinReport();
  }
  public async dialogFormVisible2() {
    this.dialogFormVisible1 = false;
    await dispatchUpdateReport(store, {
      project: this.localProject,
      id: Number(this.report_id),
      report_name: String(this.form1.name),
    });
    (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.report_id
    )[0].report_name = this.form1.name;
  }
  // 发送报告
  public save_report(is_auto?: boolean) {
    let upload_data: any;
    if (typeof is_auto === "boolean") {
      upload_data = {
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.report_id),
        file_list: this.resBase64,
        is_auto: is_auto,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        report_type: 3,
        send: this.formMail.Sender,
      };
    } else {
      upload_data = {
        // project: Number(this.$route.query.project),
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.report_id),
        file_list: this.resBase64,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        report_type: 3,
        send: this.formMail.Sender,
      };
    }

    dispatchUploadReportImage(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
    this.edit = false;
  }
  // 解析邮件收件人
  public get addressee() {
    let addressee = JSON.parse(readNewReport(store).settings).report_settings
      .notify.email.receiver_str;
    this.formMail.addressee = addressee;

    return addressee;
  }
  // 获取报告数据
  public getSkinReport() {
    this.get_skin_data = readSkinReport(store);
    this.get_skin_data.base.date = dateConversion(
      readSkinReport(store).base.date
    );
  }
  public sendOut() {
    this.edit = !this.edit;
  }
  public copyVal = {
    taskRecordId: "", //任务记录id
    deviceVal: "", //任务记录设备
  };
  // 点击删除
  public async handleDelete() {
    this.loading = true;

    await dispatchDeleteReport(store, {
      project: this.localProject,
      report_id: Number(this.report_id),
      page: 1,
      size: 1,
      report_name: "",
      new_version: "",
      old_version: "",
      risk: "",
      creator: "",
    });
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 3,
    });
    this.report_id = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });

    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.report_id),
    });
    //调用获取性能报告接口
    await dispatchGetSkinReport(store, {
      project: this.localProject,
      report_id: Number(this.report_id),
    });

    //启用生成报告的接口

    await this.getSkinReport();

    // this.selected_scene =
    //   (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];

    // 从浏览器触发发送报告
    if ("screenshot" in this.$route.query) {
      this.save_report();
    }

    // await this.addressee; //解析邮件收件人

    this.loading = false;
  }
  public generateReportVersion: any = {
    // 弹窗内——生成报告的新/旧版本
    oldEdition: [] || "",
    newEdition: [] || "",
    scenetion: [],
  };
  public report_name_placeholder = "【GR自动化性能】项目名-新版本号"; //弹窗内默认项目名称
  public dialogFormVisible = false; // 生成报告的弹窗是否可见
  public dialogFormVisibleByTask = false; // 生成报告的弹窗是否可见
  public generateReportsManually() {
    this.dialogFormVisible = true;
    this.generateReportVersion.oldEdition = "";
    this.generateReportVersion.newEdition = "";
    this.report_name_placeholder = "【GR自动化性能】项目名-新版本号";
  }
  public generateReportsManuallyByTask() {
    this.dialogFormVisibleByTask = true;
    this.generateReportVersion.oldEdition = [];
    this.generateReportVersion.newEdition = [];
    this.report_name_placeholder = "【GR自动化性能】项目名-new";
  }
  public game_scene_version = [];
  public get getDateVersionsList() {
    return readPerformanceVersion(store);
  }
  public async selectVersion() {
    await dispatchGetPerformanceVersion(store, {
      project: this.localProject,
      version: (this.generateReportVersion.newEdition as any).split("|")[0],
      timestamp:
        (this.generateReportVersion.newEdition as any).split("|")[1] || "",
    });
    this.game_scene_version = this.getDateVersionsList.scene_list;
  }
  //获取新报告数据
  public get_create_report() {
    this.new_report = readNewReport(store);
    this.new_report.create_date = dateConversion(this.new_report.create_date);
  }
  public new_report: any = {
    //新报告需要的数据类型
    id: 0,
    new_version: "",
    old_version: "",
    test_info: "",
    risk: null,
    create_date: "",
    settings: JSON.stringify({
      rule_settings: {
        change_rule: {
          increase_good: ["avg_fps"],
          threshold: {},
        },
        risk_rule: {},
        abs_risk_rule: {},
        tdr_risk_rule: {},
      },
      report_settings: {
        content: {
          core_index: ["avg_fps", "max_pss"], //核心指数
          trend_index: ["avg_fps", "max_pss"], //趋势指数
          exclude_scene: [], //排除场景
          exclude_device: [], //排除设备
          show_index: [
            "max_pss",
            "avg_fps",
            "fps_lt_10_pcnt",
            "fps_lt_18_pcnt",
            "fps_lt_25_pcnt",
          ], //显示索引
          index_type: {
            //索引类型
            basic: ["max_pss", "avg_fps"], //基础指标
            advance: ["fps_lt_10_pcnt", "fps_lt_18_pcnt", "fps_lt_25_pcnt"], //深度指标
            customize: [], //定制指标
          },
          trend_number: 10, //趋势指数
          trend_integrity: true, // 趋势图的完整性, 是否允许有缺失数据, 有断点, 1: 允许数据缺失, 0:不允许数据缺失
          red_only_change_value: false, // 是否仅标红变化值, 核心风险详情表格, 里面只标红括号内变化的值
          core_color_rule: false, // 核心指标标红规则, 1:变差就标红, 0: 超过阈值才标红
        },
        notify: {
          //通知
          email: {
            enable: false,
            receiver: [], //接收
          },
          wecom: {
            enable: false,
            receiver: [],
          },
          wecom_robot: {
            enable: false,
            receiver: [],
          },
        },
      },
    }),
    creator: "",
  };
  // 生成报告
  public async generateReportByTask() {
    this.loading = true;
    this.dialogFormVisibleByTask = false;
    await dispatchCreateReportByTask(store, {
      //调用创建报告的接口，将所需数据传递过去
      project: this.localProject,
      task_record_id: this.generateReportVersion.newEdition.join("、"),
      old_record_id: this.generateReportVersion.oldEdition.join("、"),
    });

    // 获取当前报告名称列表
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 3,
    });
    // 报告名称
    this.report_id = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    // 邮件标题
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.report_id
    )[0].report_name;
    // 邮件收件人
    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: readNewReportList(store)[0].id,
    });
    //调用获取性能报告接口
    await dispatchGetSkinReport(store, {
      project: this.localProject,
      report_id: readNewReportList(store)[0].id,
    });

    //启用生成报告的接口
    await this.get_create_report();
    await this.getSkinReport();

    this.resBase64 = [];

    await this.addressee; //解析邮件收件人
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: "",
    }); //获取任务记录的设备

    this.loading = false;
  }
  public async clear() {
    this.loading = true;
    await dispatchClearCache(store, {
      project: this.localProject,
      report_id: Number(this.report_id),
    });
    // await dispatchGetReportDetail(store, {
    //   project: this.localProject,
    //   id: Number(this.name_search),
    // });
    //调用获取性能报告接口
    await dispatchGetSkinReport(store, {
      project: this.localProject,
      report_id: Number(this.report_id),
    });

    //启用生成报告的接口
    await this.get_create_report();

    this.resBase64 = [];

    await this.getSkinReport();
    this.loading = false;
  }
  public get getDateVersions() {
    return readDateVersions(store);
  }
  public get game_version_options() {
    // const versions = this.getPerformanceSelectOptions.game_versions; //获取性能选择选项里的有些版本
    const versions = this.getDateVersions.game_versions; //获取性能选择选项里的有些版本
    const game_version_select: any[] = [];
    versions.forEach((item) => {
      if (item.value) {
        game_version_select.push({
          label: item.label,
          value: item.value,
        });
      } else {
        game_version_select.push({
          label: "空版本",
          value: "null_version",
        });
      }
    });
    return game_version_select;
  }
  // 生成报告
  public async generateReport() {
    if (
      this.generateReportVersion.oldEdition === "" ||
      this.generateReportVersion.newEdition === ""
    ) {
      alert("版本号不能为空哦！");
      return;
    }
    // if (
    //   this.generateReportVersion.oldEdition ===
    //   this.generateReportVersion.newEdition
    // ) {
    //   alert("版本号不能相同哦！");
    //   return;
    // }
    // if (
    //   this.generateReportVersion.oldEdition >
    //   this.generateReportVersion.newEdition
    // ) {
    //   alert("新版本号不能小于旧版本！");
    //   return;
    // }
    this.loading = true;
    this.dialogFormVisible = false;
    await dispatchCreateReport(store, {
      //调用创建报告的接口，将所需数据传递过去
      project: this.localProject,
      new_version: this.generateReportVersion.newEdition.split("|")[0],
      old_version: this.generateReportVersion.oldEdition.split("|")[0],
      timestamp: this.generateReportVersion.newEdition.split("|")[1],
      old_timestamp: this.generateReportVersion.oldEdition.split("|")[1], // 老版本截止日期
      // report_name: this.report_name_placeholder,
      scene_list: this.generateReportVersion.scenetion,
      report_type: 3,
    });

    // 获取当前报告名称列表
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 3,
    });
    // 报告名称

    this.report_id = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    // 邮件标题
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.report_id
    )[0].report_name;
    // 邮件收件人
    // 获取当前报告数据
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: readNewReportList(store)[0].id,
    });
    //调用获取性能报告接口
    await dispatchGetSkinReport(store, {
      project: this.localProject,
      report_id: readNewReportList(store)[0].id,
    });

    //启用生成报告的接口
    await this.get_create_report();
    await this.getSkinReport();

    this.resBase64 = [];

    await this.addressee; //解析邮件收件人
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: "",
    }); //获取任务记录的设备

    this.loading = false;
    this.dialogFormVisible = false;
  }
  //将新报告的JSON 字符串转换为对象。
  public get report_set() {
    const settings = JSON.parse(this.new_report.settings);
    return settings.report_settings;
  }
  public get rule_set() {
    const settings = JSON.parse(this.new_report.settings);
    return settings.rule_settings;
  }
  // 获取所有的索引
  public all_index(custom_index: string[]) {
    const settings = JSON.parse(this.new_report.settings);
    const index = settings.report_settings.content.index_type;
    let indexs = [];
    indexs.push(...index.basic);
    indexs.push(...index.advance);
    indexs.push(...index.customize);
    indexs.push(...custom_index);
    return indexs;
  }
  // 切换复制的id时，更新设备数据
  public async equipmentUpdate() {
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: Number(this.copyVal.taskRecordId),
    });
  }

  // 获取复制需要的任务id下拉框
  public get TaskRecordQuery() {
    return readTaskRecordQuery(store);
  }

  // 获取复制需要的设备数据下拉框
  public get TaskRecordDevices() {
    return readTaskRecordDevices(store);
  }
  //复制的接口
  public async CopyBtn() {
    this.loading = true;
    let copy = {
      project: this.localProject,
      task_record_id: this.copyVal.taskRecordId,
      device_id: this.copyVal.deviceVal,
      report_id: Number(this.$route.query.report_id),
    };
    await dispatchAovCopyPerfToReport(store, copy);
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: readNewReportList(store)[0].id,
    });
    //调用获取性能报告接口

    await dispatchGetSkinReport(store, {
      project: this.localProject,
      report_id: Number(this.$route.query.report_id),
    });

    //启用生成报告的接口
    await this.get_create_report();
    await this.getSkinReport();

    // this.selected_scene =
    //   (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];
    this.loading = false;
  }
  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  // 复制接口禁用
  public get interfaceDisabled() {
    let disabled = false;
    if (
      this.get_is_super ||
      this.copyVal.taskRecordId === "" ||
      this.copyVal.deviceVal === "" ||
      this.copyVal.deviceVal === undefined
    ) {
      disabled = true;
    }
    return disabled;
  }
  public get gameList() {
    const list = [
      "皮肤ID",
      "英雄",
      "皮肤名",

      "动作",
      "动画时长",
      "帧率均值",
      "帧率方差",
      "低于40帧占比(%)",
      "低于20帧占比(%)",
      "最低帧",
      "CPU占用均值(%)",
      "PSS均值(MB)",
      "PSS峰值(MB)",
      "VSS峰值(MB)",
      "VSS均值(MB)",
      "链接",
    ];
    return list;
  }
}
